import React, { useState } from 'react';

import {  Modal } from 'reactstrap';





const ModalEditAddress = (props) => {
    

    const [showEditAddress, setShowEditAddress] = useState("")

   const [datoId, setDatoId] = useState("")
console.log(setDatoId)



    return ( 
        <React.Fragment>
               {/* Modal de Editar Direccion */}
               <Modal
                    isOpen={showEditAddress}
                    centered={true}
                    toggle={()=> {
                      setShowEditAddress(false)
                    }} 
                  >
                    <div className="modal-header">
                      <h3 className="modal-title mt-2">
                        Editar direccion
                      </h3>
                      <button
                        type='button'
                        onClick={()=>{
                          setShowEditAddress(false)
                        }}
                        className='close'
                        data-dismiss='modal'
                        aria-label='Close'
                      >
                        <span aria-hidden='true'>&times</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <select
                          className='form-select'
                          id= 'tipo_Contacto'
                          name='tipo_Conatcto'
                          
                          defaultValue={datoId.label}
                          placeholder="Tipo de Contacto"    
                        //   onChange={handleDireccion1Change}           
                      >

                      {/* {
                        optionGroupLabel3[0].options.map((option, index) => (
                          <option key={index} value={option.value}>{option.label}</option>
                        ))
                      } */}
                      </select>


                    <div className="modal-footer">
                      <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => {
                            // setdireccion1_txt("");
                            setShowEditAddress(false)
                          }}
                      >
                          Cerrar
                      </button>
                      <button
                          type="button"
                          className="btn btn-primary"
                        //   onClick={()=> {
                        //     if(direccion1_txt !== ""){
                        //       setdireccion2(true); 
                        //       setdireccion1(false);
                        //     }
                        //     else{
                        //       setError(true);
                        //     }
                        //   }}
                      >
                          Siguiente
                      </button>
                    </div>
                </div>

                  </Modal>
        </React.Fragment>
     );
}
 
export default ModalEditAddress;